export default __webpack_public_path__ + "static/media/HDOT-USDT.0c237014.svg";